import React, { createContext, useContext, useState, ReactNode } from "react";
import { mapBounds } from "../constants/Map";
import L from "leaflet";

// Định nghĩa các loại nội dung sidebar
export type SidebarContentType =
	| "none"
	| "searchVessel"
	| "tracker"
	| "chatList"
	| "warningZoneList"
    | "warningZoneCreateForm"
	| "warningZoneUpdateForm"
    | "chatMessage"
    | "warningZoneChatMessage"
	| "warningZoneVesselList";

interface SidebarContextType {
	isOpen: boolean;
	contentType: SidebarContentType;
	openSidebar: (type: SidebarContentType) => void;
	closeSidebar: () => void;
	setContentType: (type: SidebarContentType) => void;
	vesselBeingTrackedId: string;
	setVesselBeingTrackedId: (id: string) => void;
	chosenPosition: L.LatLng;
	setChosenPosition: (pos: L.LatLng) => void;
	chatBeingViewedId: string;
	setChatBeingViewedId: (id: string) => void;
	chosenWarningZoneId: string;
	setChosenWarningZoneId: (id: string) => void;
	draggableCirclePosition: L.LatLng;
	setDraggableCirclePosition: (pos: L.LatLng) => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [contentType, setContentType] = useState<SidebarContentType>("none");
	const [vesselBeingTrackedId, setVesselBeingTrackedId] = useState<string>("");
	const [chosenPosition, setChosenPosition] = useState<L.LatLng>(L.latLng(0,0));
	const [chatBeingViewedId, setChatBeingViewedId] = useState<string>("");
	const [chosenWarningZoneId, setChosenWarningZoneId] = useState<string>("");
	const [draggableCirclePosition, setDraggableCirclePosition] = useState<L.LatLng>(mapBounds.getCenter());
	const openSidebar = (type: SidebarContentType) => {
		setContentType(type);
		setIsOpen(true);
	};

	const closeSidebar = () => {
		setIsOpen(false);
		setContentType("none");
		setVesselBeingTrackedId("");
		setChosenPosition(L.latLng(0,0));
		setChatBeingViewedId("");
	};

	return (
		<SidebarContext.Provider value={{setDraggableCirclePosition, draggableCirclePosition, chosenWarningZoneId: chosenWarningZoneId, setChosenWarningZoneId: setChosenWarningZoneId, chatBeingViewedId, setChatBeingViewedId, chosenPosition, setChosenPosition, isOpen, contentType, openSidebar, closeSidebar, setContentType, vesselBeingTrackedId, setVesselBeingTrackedId }}>
			{children}
		</SidebarContext.Provider>
	);
};

export const useSidebarContext = () => {
	const context = useContext(SidebarContext);
	if (!context) {
		throw new Error("useSidebarContext must be used within a SidebarProvider");
	}
	return context;
};
